import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "input-group-btn" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_8 = { class: "checkbox-wrapper" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_10 = { class: "float-end float-start-sm" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12" };
const _hoisted_12 = { class: "card bg-white data-grid company-detail-grid detached" };
const _hoisted_13 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_14 = { class: "hidden-sm" };
const _hoisted_15 = { class: "hidden-sm" };
const _hoisted_16 = { class: "hidden-sm" };
const _hoisted_17 = { class: "text-center hidden-sm" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = { class: "hidden-sm" };
const _hoisted_20 = { class: "hidden-sm" };
const _hoisted_21 = { class: "hidden-sm" };
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_24 = { class: "clearfix" };
const _hoisted_25 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_26 = { class: "invalid-feedback" };
const _hoisted_27 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_28 = { class: "invalid-feedback" };
const _hoisted_29 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_30 = { class: "clearfix" };
const _hoisted_31 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_32 = { class: "invalid-feedback" };
const _hoisted_33 = { class: "float-end mt-1" };
const _hoisted_34 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_35 = { class: "invalid-feedback" };
const _hoisted_36 = { class: "float-end mt-1" };
const _hoisted_37 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_38 = { class: "invalid-feedback" };
const _hoisted_39 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "text",
                            modelValue: _ctx.query.keywords,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Search for...",
                            onKeyup: _withKeys(_ctx.search, ["enter"]),
                            required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-default",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.search && _ctx.search(...args)))
                            }, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                ]))])
                        ])
                    ])
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_b_form_checkbox, {
                            id: "includeArchivedContacts",
                            modelValue: _ctx.query.includeDeleted,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ]),
                _cache[21] || (_cache[21] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _ctx.add
                        }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Add Contact", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ]),
            _cache[41] || (_cache[41] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _cache[22] || (_cache[22] = _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* CACHED */)),
                                _cache[23] || (_cache[23] = _createTextVNode()),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'FirstName', title: 'Name' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[24] || (_cache[24] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_14, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'Position', title: 'Position' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[25] || (_cache[25] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_15, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'MobilePhone', title: 'Mobile Ph.' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[26] || (_cache[26] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_16, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'EmailAddress', title: 'Email' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ])
                            ])
                        ]),
                        _cache[38] || (_cache[38] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: _normalizeClass({ 'deleted': item.whenDeleted })
                                }, [
                                    _createElementVNode("td", _hoisted_17, [
                                        _createVNode(_component_b_dropdown, {
                                            variant: "outline-secondary dots",
                                            size: "sm",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.edit(item))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                            _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]),
                                                _cache[30] || (_cache[30] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_divider),
                                                _cache[31] || (_cache[31] = _createTextVNode()),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.archive(item))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                            _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]), [
                                                    [_vShow, !item.whenDeleted]
                                                ]),
                                                _cache[32] || (_cache[32] = _createTextVNode()),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.restore(item))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                            _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]), [
                                                    [_vShow, item.whenDeleted]
                                                ])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                    ]),
                                    _cache[33] || (_cache[33] = _createTextVNode()),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: "blue pointer",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 9 /* TEXT, PROPS */, _hoisted_18)
                                    ]),
                                    _cache[34] || (_cache[34] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_19, _toDisplayString(item.position), 1 /* TEXT */),
                                    _cache[35] || (_cache[35] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_20, _toDisplayString(item.mobilePhone || item.workPhone), 1 /* TEXT */),
                                    _cache[36] || (_cache[36] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_21, _toDisplayString(item.emailAddress), 1 /* TEXT */)
                                ], 2 /* CLASS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _cache[39] || (_cache[39] = _createTextVNode()),
                        _createElementVNode("tfoot", null, [
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[37] || (_cache[37] = [
                                        _createElementVNode("td", {
                                            class: "text-center",
                                            colspan: "5"
                                        }, [
                                            _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
                                        ], -1 /* CACHED */)
                                    ]))]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]),
                _cache[40] || (_cache[40] = _createTextVNode()),
                _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_b_pagination, {
                        class: "float-end",
                        modelValue: _ctx.query.pageNo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                        "per-page": _ctx.query.pageSize,
                        "total-rows": _ctx.data.recordCount,
                        "hide-ellipsis": true,
                        disabled: _ctx.working
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _cache[78] || (_cache[78] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "contact_popup",
            modelValue: _ctx.editingPerson,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.editingPerson) = $event)),
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("\r\n\t\t\t\tContact\r\n\t\t\t", -1 /* CACHED */)
                ]))]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.save(_ctx.person)))
                    }, {
                        default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createTextVNode(" Save\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }),
                    _cache[73] || (_cache[73] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.archive(_ctx.person)))
                    }, {
                        default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                _createTextVNode(" Archive\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.person.personId && !_ctx.person.whenDeleted]
                    ]),
                    _cache[74] || (_cache[74] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "warning",
                        onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.restore(_ctx.person)))
                    }, {
                        default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                _createTextVNode(" Restore\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.person.personId && _ctx.person.whenDeleted]
                    ]),
                    _cache[75] || (_cache[75] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Close\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _cache[76] || (_cache[76] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _cache[43] || (_cache[43] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tFirst Name *\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[44] || (_cache[44] = _createTextVNode()),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.firstNameVal, {
                                    type: "text",
                                    modelValue: _ctx.person.firstName,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.person.firstName) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "firstName",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.firstName },
                                    maxlength: "50"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _cache[45] || (_cache[45] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_26, "\r\n\t\t\t\t\t\t\t* Please enter a first name\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.firstName]
                                ])
                            ]),
                            _cache[51] || (_cache[51] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_27, [
                                _cache[46] || (_cache[46] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tLast Name *\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[47] || (_cache[47] = _createTextVNode()),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.lastNameVal, {
                                    type: "text",
                                    modelValue: _ctx.person.lastName,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.person.lastName) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "lastName",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.lastName },
                                    maxlength: "50"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _cache[48] || (_cache[48] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_28, "\r\n\t\t\t\t\t\t\t* Please enter a last name\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.lastName]
                                ])
                            ]),
                            _cache[52] || (_cache[52] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_29, [
                                _cache[49] || (_cache[49] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tPosition\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[50] || (_cache[50] = _createTextVNode()),
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.person.position,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.person.position) = $event)),
                                    modelModifiers: { trim: true },
                                    maxlength: "50"
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ])
                        ]),
                        _cache[68] || (_cache[68] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _cache[54] || (_cache[54] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tEmail\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[55] || (_cache[55] = _createTextVNode()),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.emailVal, {
                                    type: "email",
                                    modelValue: _ctx.person.emailAddress,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.person.emailAddress) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "email",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.email },
                                    maxlength: "255"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _cache[56] || (_cache[56] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_32, "\r\n\t\t\t\t\t\t\t* Please enter a valid email\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.email]
                                ]),
                                _cache[57] || (_cache[57] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.testEmail())),
                                        disabled: !_ctx.validEmail
                                    }, {
                                        default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                                _createElementVNode("i", { class: "fa fa-envelope-o" }, null, -1 /* CACHED */),
                                                _createTextVNode(" Test Email\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled"])
                                ])
                            ]),
                            _cache[66] || (_cache[66] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_34, [
                                _cache[59] || (_cache[59] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tMobile Phone\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[60] || (_cache[60] = _createTextVNode()),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.mobilePhoneVal, {
                                    type: "tel",
                                    modelValue: _ctx.person.mobilePhone,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.person.mobilePhone) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "mobilePhone",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.mobilePhone },
                                    maxlength: "50"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _cache[61] || (_cache[61] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_35, "\r\n\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.mobilePhone]
                                ]),
                                _cache[62] || (_cache[62] = _createTextVNode()),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.testSMS())),
                                        disabled: !_ctx.validMobilePhone
                                    }, {
                                        default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                                _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* CACHED */),
                                                _createTextVNode(" Test SMS\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled"])
                                ])), [
                                    [_directive_cloud_only]
                                ])
                            ]),
                            _cache[67] || (_cache[67] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_37, [
                                _cache[63] || (_cache[63] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tWork Phone\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[64] || (_cache[64] = _createTextVNode()),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.workPhoneVal, {
                                    type: "tel",
                                    modelValue: _ctx.person.workPhone,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.person.workPhone) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "workPhone",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.workPhone },
                                    maxlength: "50",
                                    required: ""
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _cache[65] || (_cache[65] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_38, "\r\n\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.workPhone]
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[77] || (_cache[77] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ]));
}
